import { useState, useEffect } from 'react';

const useDebounce = (value = '', delay = 2000) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  // Intentional: debounce synchronizes with setTimeout (external timing system)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};

export default useDebounce;
